module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ScoreView.js"));
	}, "ScoreView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ScoreView!./src/pages/Shop/Member/Wallet/Score/ScoreView.js
// module id = 1068
// module chunks = 431